import { pharmacy_intiate_chat } from "../../../networking/urlEndPoints";
import Axios from "../../../networking/intraceptor";
import Cookies from "js-cookie";

// export async function fecthAllGroupPreviousMessages(group_id, last_message_id, setGroupMessages, groupMessages, setLoadGroupMessages, chatBodyRef) {
// 	try {
// 		setLoadGroupMessages(true)

// 		const chatBody = chatBodyRef.current;
// 		const previousScrollTop = chatBody.scrollTop;

// 		const response = await Axios.post(`${pharmacy_get_previous_messages}`, {
// 			group_id: group_id,
// 			last_message_id: last_message_id
// 		});

// 		if (response?.status === 200) {
// 			const newMessages = response?.data?.data || [];
// 			const mergedMessages = [...newMessages, ...groupMessages];

// 			setGroupMessages(mergedMessages);
// 			setLoadGroupMessages(false)

// 			if (response?.data?.data?.length === 0) {
// 				Cookies.set('previous', 'empty')
// 			}
// 			const newMessagesCount = newMessages.length;
// 			const lineHeight = 60
// 			const newScrollHeight = newMessagesCount * lineHeight;
// 			chatBody.scrollTo(0, previousScrollTop + newScrollHeight);
// 		}
// 	} catch (error) {
// 		if (error?.response) {
// 			setLoadGroupMessages(false)

// 		}
// 	}
// }

// export async function fecthAllGroupPreviousMessages(group_id, last_message_id, setGroupMessages, groupMessages, setLoadGroupMessages, chatBodyRef, requestedData) {
// 	try {
// 		setLoadGroupMessages(true)

// 		const chatBody = chatBodyRef.current;
// 		const previousScrollTop = chatBody.scrollTop;

// 		const response = await Axios.post(`${pharmacy_intiate_chat}`, requestedData);

// 		if (response?.status === 200) {
// 			const newMessages = response?.data?.data?.messages || [];
// 			// const mergedMessages = [...newMessages, ...groupMessages];

// 			// setGroupMessages(mergedMessages);
// 			setLoadGroupMessages(false)

// 			if (response?.data?.data?.length === 0) {
// 				Cookies.set('previous', 'empty')
// 			}
// 			const newMessagesCount = newMessages.length;
// 			const lineHeight = 60
// 			const newScrollHeight = newMessagesCount * lineHeight;
// 			chatBody.scrollTo(0, previousScrollTop + newScrollHeight);
// 		}
// 	} catch (error) {
// 		if (error?.response) {
// 			setLoadGroupMessages(false)

// 		}
// 	}
// }




export async function fecthAllGroupPreviousMessages(setGroupMessages, groupMessages, setLoadGroupMessages, chatBodyRef, requestedData) {
	try {
		setLoadGroupMessages(true);

		const chatBody = chatBodyRef.current;
		const previousScrollTop = chatBody.scrollTop;

		const response = await Axios.post(`${pharmacy_intiate_chat}`, requestedData);

		if (response?.status === 200) {
			const newMessages = response?.data?.data?.messages || [];

			const mergedMessages = { ...groupMessages };

            // Iterate over each date in the new messages
            Object.keys(newMessages).forEach(dateKey => {
                if (mergedMessages[dateKey]) {
                    // Merge new messages with existing ones for the date
                    const combinedMessages = [...mergedMessages[dateKey], ...newMessages[dateKey]];

                    // Remove duplicates based on 'id' field
                    const uniqueMessages = Array.from(new Set(combinedMessages.map(msg => msg.id)))?.map(id => combinedMessages.find(msg => msg.id === id));

                    // Sort the messages by 'id' in ascending order
                    mergedMessages[dateKey] = uniqueMessages.sort((a, b) => a.id - b.id);
                } else {
                    // If the date doesn't exist, add the new messages and sort by 'id'
                    mergedMessages[dateKey] = newMessages[dateKey].sort((a, b) => a.id - b.id);
                }
            });

			setGroupMessages(mergedMessages);

			setLoadGroupMessages(false);

			// Set cookie if there are no more messages
			if (newMessages.length === 0) {
				Cookies.set('previous', 'empty');
			}

			// Adjust scroll position to maintain view after adding new messages
			const newMessagesCount = newMessages.length;
			const lineHeight = 60; // Adjust according to message element height
			const newScrollHeight = newMessagesCount * lineHeight;
			chatBody.scrollTo(0, previousScrollTop + newScrollHeight);
		}
	} catch (error) {
		console.error('Error fetching messages:', error);
		setLoadGroupMessages(false);
	}
}
